export class MonitorScreenService {
    constructor(monitorUrlTemplate) {
        this.monitorUrlTemplate = monitorUrlTemplate;
    }
    createMonitorUrl(roomId) {
        return this.monitorUrlTemplate.replace('{roomId}', roomId);
    }
    openMonitor(roomId) {
        const monitorUrl = this.createMonitorUrl(roomId);
        console.log({ monitorUrl });
        return window.open(monitorUrl, 'monitor_screen');
    }
}
